import { useQuery } from "@tanstack/react-query";
import { Api } from "@/api";
import { usersKeys } from "./keys";

/** Загружает пользователей для управления ролями в админке. */
export const useListUsers = () => {
	const query = useQuery({ queryFn: Api.User.getApiUsers, queryKey: usersKeys.list });
	return {
		data: query.data?.data ?? [],
		execute: async () => query.refetch(),
		isPending: query.isPending,
	};
};
